export { PromosTotals } from './PromosTotals';
